import { render, staticRenderFns } from "./PersonAvatar.vue?vue&type=template&id=df1f1f4e&scoped=true"
import script from "./PersonAvatar.vue?vue&type=script&lang=js"
export * from "./PersonAvatar.vue?vue&type=script&lang=js"
import style0 from "./PersonAvatar.vue?vue&type=style&index=0&id=df1f1f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1f1f4e",
  null
  
)

export default component.exports